"use client";

import type { FieldErrors } from "react-hook-form";
import type { ComposeFormValues } from "@/lib/types/compose-modal-types";

interface ComposeValidationSummaryProps {
  formErrors: FieldErrors<ComposeFormValues>;
}

export function ComposeValidationSummary({ formErrors }: ComposeValidationSummaryProps) {
  const hasErrors = Object.keys(formErrors).length > 0;

  if (!hasErrors) {
    return null;
  }

  return (
    <div className="bg-red-50 dark:bg-red-950/40 border border-red-300 dark:border-red-800 rounded-md p-4">
      <div className="flex items-start gap-2">
        <div className="text-red-700 dark:text-red-300 font-semibold text-sm">Validation errors</div>
      </div>
      <ul className="mt-3 space-y-2">
        {Object.entries(formErrors).map(([fieldName, error]) => (
          <li key={fieldName} className="text-sm text-red-700 dark:text-red-300 font-medium">
            • <span className="capitalize">{fieldName}:</span>{" "}
            {error?.message || `${fieldName} is invalid`}
          </li>
        ))}
      </ul>
    </div>
  );
}
